export default {
  reset: (state) => {
    state.item = {};
    state.errors = [];
    state.isLoading = false;
  },
  setItem: (state, item) => {
    state.item = item;
  },
  setIsLoading: (state, isLoading) => {
    state.isLoading = isLoading;
  },
  addLecture: (state, lecture) => {
    if (!lecture) {
      lecture = {
        name: null,
        content: null,
        video: {
          videoUrl: null,
          content: null,
        },
        material: {
          content: null,
          files: [],
        },
      };
    }

    if (!state.item.lectures) {
      state.item = { ...state.item, lectures: [] };
    }

    state.item.lectures.push(lecture);
  },
  removeLecture: (state, index) => {
    if (!state.item.lectures || !state.item.lectures[index]) {
      return;
    }
    state.item.lectures.splice(index, 1);
  },
  updateLecture: (state, payload) => {
    if (!state.item.lectures || !state.item.lectures[payload.index]) {
      return;
    }
    const lectures = state.item.lectures;
    lectures.splice(payload.index, 1, payload.data);

    state.item = { ...state.item, lectures };
  },
  setErrors: (state, errors) => {
    state.errors = errors;
  },
};
